import React from "react";

// prettier-ignore
const defaultValues = {
  user: { value: undefined, set: () => {} },
};

export const StateContext = React.createContext(defaultValues);
